import { NodeWrapper } from "./NodeWrapper";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW } from "./nodeStyles";
import { ScheduleOutlined as Schedule, ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete } from '@mui/icons-material';
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(CoreTooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();

  const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#06B6D4">
      {/* Floating Toolbar */}
      

      <Handle type="target" position="left" style={{
      background: "#06B6D4",
      width: "10px",
      height: "20px",
      borderRadius: "4px",
      left: "-12px",
      cursor: "pointer",
      border: '2px solid white',
      top: "20px"
    }} onConnect={params => console.log("handle onConnect", params)} isConnectable={isConnectable}>
      </Handle>

      {/* Header */}
      <div style={mkHeaderStyle("#06B6D4")}>
        <Schedule style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>{data.name || i18n.t("flowBuilder.editor.nodes.retargeting.name") || "Retargeting"}</div>
      
        <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#22d3ee' }}>
                💡 {i18n.t("flowBuilder.tooltips.retargeting.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.retargeting.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>

      <div style={NODE_BODY_STYLE}>
        <div style={{
        color: "#334155",
        fontSize: "12px",
        fontWeight: "500"
      }}>
          {data?.tasks?.length ? <div style={{
          marginBottom: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "4px"
        }}>
               {data.tasks.map((task, idx) => {
            const counts = (task.content || []).reduce((acc, item) => {
              acc[item.type] = (acc[item.type] || 0) + 1;
              return acc;
            }, {});
            const summary = Object.entries(counts).map(([type, count]) => {
              let typeLabel = type;
              if (type === 'text') typeLabel = 'Texto';
              if (type === 'image') typeLabel = 'Imagen';
              if (type === 'video') typeLabel = 'Video';
              if (type === 'audio') typeLabel = 'Audio';
              if (type === 'document') typeLabel = 'Doc';
              if (type === 'ai_reactivation') typeLabel = 'IA';
              return `${count} ${typeLabel}`;
            }).join(", ");
            const unit = task.waitUnit === 'minutes' ? 'Minutos' : task.waitUnit === 'hours' ? 'Horas' : 'Días';
            return <div key={idx} style={{
              padding: "4px 8px",
              backgroundColor: "#f1f5f9",
              borderRadius: "4px",
              borderLeft: "2px solid #3b82f6",
              fontSize: "11px"
            }}>
                     <strong>#{idx + 1}</strong> {task.waitTime} {unit} <br />
                     <span style={{
                color: "#64748b"
              }}>({summary || "Sin contenido"})</span>
                   </div>;
          })}
             </div> : <div style={{
          marginBottom: "8px",
          color: "#94a3b8"
        }}>
               Sin tareas configuradas
             </div>}
          
          <div style={{
          marginTop: "8px",
          fontSize: "11px",
          color: "#64748b",
          borderTop: "1px solid #e2e8f0",
          paddingTop: "6px"
        }}>
            {i18n.t("flowBuilder.editor.nodes.retargeting.immediateContinuation") || "Continuación Inmediata"}
          </div>
        </div>
      </div>
      <Handle type="source" position="right" id="next" style={{
      background: "#06B6D4",
      width: "10px",
      height: "20px",
      borderRadius: "4px",
      right: "-12px",
      cursor: "pointer",
      border: '2px solid white',
      top: "70px"
    }} isConnectable={isConnectable}>
      </Handle>
    </NodeWrapper>;
});
